<div class="page">
  <h1 class="page-title">{{ 'general.ACCOUNT' | transloco }}</h1>

  <!-- User card -->
  <div class="section-card user-card">
    <div class="avatar">{{ initials }}</div>
    <div class="user-info">
      <span class="user-name">{{ fullName }}</span>
      @if (email) {
        <span class="user-email">{{ email }}</span>
      }
    </div>
  </div>

  <!-- HELP section -->
  <span class="section-label">{{ 'general.HELP_SECTION' | transloco }}</span>
  <div class="section-card">
    <div class="list-row" (click)="openMailto()">
      <span class="row-label">{{ 'general.CONTACT_SUPPORT' | transloco }}</span>
      <div class="row-end">
        <span class="row-value">{{ 'general.HELP_EMAIL' | transloco }}</span>
        <qai-icon kind="chevron-right" size="16px" class="row-icon"></qai-icon>
      </div>
    </div>
    <div class="divider"></div>
    <div class="list-row" (click)="openExternal(webAppUrl)">
      <span class="row-label">{{ 'general.OPEN_WEB_APP' | transloco }}</span>
      <qai-icon kind="link-external" size="16px" class="row-icon"></qai-icon>
    </div>
    <div class="divider"></div>
    <div class="list-row" (click)="openExternal(knowledgeBaseUrl)">
      <span class="row-label">{{ 'general.SEARCH_KNOWLEDGE_BASE' | transloco }}</span>
      <qai-icon kind="link-external" size="16px" class="row-icon"></qai-icon>
    </div>
  </div>

  <!-- ABOUT section -->
  <span class="section-label">{{ 'general.ABOUT_SECTION' | transloco }}</span>
  <div class="section-card">
    <div class="list-row" (click)="openExternal(privacyPolicyUrl)">
      <span class="row-label">{{ 'general.PRIVACY_POLICY' | transloco }}</span>
      <qai-icon kind="link-external" size="16px" class="row-icon"></qai-icon>
    </div>
    <div class="divider"></div>
    <div class="list-row" (click)="openExternal(termsUrl)">
      <span class="row-label">{{ 'general.TERMS_OF_SERVICE' | transloco }}</span>
      <qai-icon kind="link-external" size="16px" class="row-icon"></qai-icon>
    </div>
    <div class="divider"></div>
    <div class="list-row no-action">
      <span class="row-label">{{ 'general.VERSION' | transloco }}</span>
      <span class="row-value">{{ appVersion }}</span>
    </div>
  </div>

  <!-- Log out -->
  <div class="section-card logout-card" (click)="logout()">
    <span class="logout-text">{{ 'general.LOG_OUT' | transloco }}</span>
  </div>
</div>
